import { Injectable } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { SALES_TOUCH_SOURCE_QUERY_PARAM } from '../../param/types/sales-touch-source.nba-param-resolver';
import { NbaConditionResolver } from '../nba-condition-resolver.interface';

import { NbaConditionResolverId } from './nba-condition-resolver-id.enum';

const SALES_TOUCH_SOURCES = new Set(['stouch', 'stouchint', 'stouchdev', 'stouchuat']);

@Injectable()
export class IsSalesTouchSourceParameterAvailableResolver implements NbaConditionResolver {
  public readonly identifier: string = NbaConditionResolverId.IsSalesTouchSourceParameterAvailable;

  public constructor(private readonly route: ActivatedRoute) {}

  /**
   * @returns (observable of) true if sales touch query parameter 'source' is available and has a correct value, false otherwise
   */
  public resolve$(): Observable<boolean> {
    return this.route.queryParamMap.pipe(
      map((params: ParamMap) => {
        const salesTouchSource = params.get(SALES_TOUCH_SOURCE_QUERY_PARAM);
        return !!salesTouchSource && SALES_TOUCH_SOURCES.has(salesTouchSource);
      })
    );
  }
}
